import React from 'react'
import { Trans } from '@local/translations'

export const ToastTOSAndPrivacy = () => {
  return (
    <Trans
      i18nKey='toast-tos-and-privacy.terms-and-privacy'
      components={{
        TermsLink: (
          <a
            href='https://pos.toasttab.com/terms-of-service/#diner-tos'
            rel='noopener noreferrer'
            target='_blank'
          />
        ),
        PrivacyLink: (
          <a
            href='https://pos.toasttab.com/privacy'
            rel='noopener noreferrer'
            target='_blank'
          />
        )
      }}
    />
  )
}
export const CAInfo = () => {
  return (
    <Trans
      i18nKey='ca-info.residents-info'
      components={{
        PrivacyLink: (
          <a
            href='https://pos.toasttab.com/privacy#addendum-a'
            rel='noopener noreferrer'
            target='_blank'
          />
        )
      }}
    />
  )
}
